import {createAction} from '@reduxjs/toolkit';

export const cacheCleared = createAction('cache/cleared');
